import { CountUp } from '../../../node_modules/countup.js/dist/countUp.umd';

export default function initCountUp() {
  const blocks = document.querySelectorAll('.js-count-up-block');

  const options = {
    threshold: 0.5,
  };

  const startCountUp = (block) => {
    const numbers = block.querySelectorAll('.js-count-up');
    numbers.forEach((numberEl) => {
      // Preserve decimal numbers correctly
      const targetValue = parseFloat(numberEl.textContent.replace(/[^\d.]/g, ''));

      const countUp = new CountUp(numberEl, targetValue, {
        duration: 2,
        decimalPlaces: targetValue % 1 !== 0 ? 1 : 0, // Show 1 decimal place if needed
      });

      if (!countUp.error) {
        countUp.start();
      } else {
        console.error(countUp.error);
      }
    });
  };

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        startCountUp(entry.target);
        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, options);

  blocks.forEach((block) => observer.observe(block));
}
